/**
 * PositionSelectOrgList 岗位选择组织列表
 * @author mll
 * @date 2020-01-08
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import { framework_tool, component_tool, utils_tool } from '@/tool'
import PositionSelectOrg from './positionSelectOrg/positionSelectOrg'
let { WizContainer } = framework_tool;
let { WizCol, WizRow, WizButton, WizModal, WizList } = component_tool;
import '../../../../../styles/containers/org/position/positionSelectOrg.less'

class PositionSelectOrgList extends WizContainer {

  componentName = 'PositionSelectOrgList';

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      visible: false
    };
  }

  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value });
    }
  }

  /**
   * 监控选择modal的返回值，并且将值反馈给Form
   */
  triggerChange = (nextTargetKeys) => {
    const { onChange } = this.props;
    this.setState({
      value: nextTargetKeys,
      date: new Date().getTime()
    });
    if (onChange) {
      onChange(nextTargetKeys);
    }
  };

  /**
   * 打开modal
   */
  showModal = () => {
    this.setState({
      visible: true
    });
  };

  /**
   * 确定按钮
   */
  onSubmit = () => {
    const { onChange } = this.props;
    const { value } = this.state;
    this.setState({
      visible: false
    });
    if (onChange) {
      onChange(value);
    }
  };

  /**
   * 关闭modal
   */
  hideModal = () => {
    this.setState({
      visible: false
    });
  };

  /**
   * 监控选择modal的table row被选中时的值，并且将值反馈给Form
   */
  onSelectChange = (key) => {
    let { value } = this.state;
    const { onChange } = this.props;
    let _value = []
    if (key && value && value.length > 0) {
      value.forEach(val => {
        if (val['id'] !== key) {
          _value.push(val)
        }
      });
    }
    this.setState({
      value: _value,
      date: new Date().getTime()
    }, () => {
      onChange && onChange(_value);
    });
  };

  /**
   * 渲染列表
   */
  _renderList() {
    const { placeholder, ...otherProps } = this.props;
    let list = otherProps.value;
    if (list && list.length > 0) {
      return (
        <WizList
          className='position-select-org-list'
          itemLayout="vertical"
          bordered
          size={'small'}
          header={<>组织名称</>}
          dataSource={list}
          locale={{ emptyText: '未选择组织' }}
          renderItem={item => (
            <WizList.Item
              extra={<WizButton onClick={() => { this.onSelectChange(item['id']) }}>删除</WizButton>}
            >
              {item.name}
            </WizList.Item>
          )}
        />
      )
    }
  }

  /**
   * 渲染modal框内的内容
   */
  _renderSelect() {
    return (
      <PositionSelectOrg
        key={new Date().getTime()}
        show={this.state.visible}
        selectedRows={this.props.value ? [...this.props.value] : []}
        updateRows={rows => this.triggerChange(rows)}
        handleClear={id => this.onSelectChange(id)}
        itemRender={(item) => {
          return (
            <WizRow key={item.id}>
              <WizCol>{item.name}</WizCol>
            </WizRow>
          )
        }}
        hideModal={this.hideModal}
      />
    )
  }

  _render() {
    const { modal, placeholder, ...otherProps } = this.props;
    return (
      <>
        <>
          {this._renderList()}
        </>
        <WizModal
          className="antui-transfer-modal"
          title={'请选择' + otherProps.title}
          visible={this.state && this.state.visible}
          width={modal.width || 1000}
          footer={null}
          {...modal}
          onCancel={this.hideModal}
          maskClosable
        >
          {this._renderSelect()}
        </WizModal>
        <WizButton type="primary" onClick={otherProps.disabled ? () => { } : this.showModal}>添加</WizButton>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
};

export default connect(mapStateToProps)(PositionSelectOrgList);
